module.exports = __webpack_public_path__ + "static/media/topics.d44f14f8.png";